import React from 'react';
import { ccwSteps } from '../../data/homeContent';
import { Reveal } from '../ui/Reveal';
export function CcwStepsList() {
  return <ol className="relative grid gap-10 md:grid-cols-2 xl:grid-cols-4 xl:gap-8" data-id="element-442" data-mp="1x6q6z0gcr93e">
      <span className="absolute left-0 right-0 top-7 hidden h-px bg-navy/15 xl:block" aria-hidden="true" data-id="element-443" data-mp="1sa9drruaq4jg" />
      {ccwSteps.map((step, i) => <li key={step.title} className="relative" data-id="element-444" data-mp="1n8adwrxrlpr9" data-mpi={i}>
          <Reveal delay={i * 0.05} data-id="element-445" data-mp="2kwu89162iwr8">
            <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-navy font-display text-2xl font-bold text-white ring-8 ring-white" data-id="element-446" data-mp="2kvsu2ntr9u5a">
              {i + 1}
            </span>
            <h3 className="t-h3 mt-6 text-navy" data-id="element-447" data-mp="2b1k4o900uhbc">{step.title}</h3>
            <p className="mt-2 max-w-[28rem] leading-relaxed text-steel" data-id="element-448" data-mp="26xch4f5av7ep">{step.body}</p>
          </Reveal>
        </li>)}
    </ol>;
}